<rtn-simple-modals #simpleModals class="logout-modal"></rtn-simple-modals>